import { createMuiTheme } from '@material-ui/core';
import { EColors } from '../types/enums/EColors';
import { stylesConstants } from './stylesConstants';
import { themeColors } from './themeColors';

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: EColors.LushBlue,
    },
    secondary: {
      main: EColors.RaspberryRed,
    },
    background: { default: EColors.White },
  },
  typography: {
    fontFamily: `Roboto`,
    h4: {
      fontSize: '28px',
    },
  },
  overrides: {
    MuiButton: {
      label: {
        textTransform: 'none',
        color: EColors.White,
      },

      root: {
        height: stylesConstants.buttonHeight,
      },

      contained: {
        backgroundColor: EColors.Silver,
      },
    },

    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: themeColors.borders,
      },
    },

    MuiSwitch: {
      root: {
        ...stylesConstants.switch.container,
        padding: 0,
      },
      switchBase: {
        padding: 1,
        '&$checked': {
          transform: 'translateX(16px)',
          color: EColors.White,
          '& + $track': {
            opacity: 1,
          },
        },
      },
      thumb: {
        ...stylesConstants.switch.thumb,
        color: EColors.White,
      },
      track: {
        borderRadius: stylesConstants.switch.container.height / 2,
        backgroundColor: EColors.Silver,
      },
      checked: {},
    },
    MuiTextField: {
      root: {
        backgroundColor: themeColors.innerBackground,
      },
    },
  },
  props: {
    MuiButton: {
      variant: 'contained',
      color: 'default',
      disableElevation: true,
    },
    MuiTextField: {
      variant: 'outlined',
      inputProps: {
        style: { fontSize: '14px' },
      },
    },
    MuiSelect: {
      variant: 'outlined',
    },
  },
});
